// extracted by mini-css-extract-plugin
module.exports = {"main_intro":"index_main_intro_18VA9","more_info":"index_more_info_2Rswu","image":"index_image_2X_og"};